import React from "react";
import styled from "styled-components";

const Element = styled.div`
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #e96159;
  background: #f5f5f5;
  padding: 16px;
  border-top: 1px solid #e96159;
`;

const ElementInverted = styled.div`
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #ffffff;
  background: #e96159;
  padding: 16px;
  border-top: 1px solid #ffffff;
`;

const Date = styled.span`
  float: right;
`;

export default function Footer({ children, inverted, callback }) {
  return inverted ? (
    <ElementInverted>
      Fazenda Cósmica |{" "}
      <a
        href="https://goo.gl/maps/4HjVzJgsr1uRxTAX6"
        target="_blank"
        rel="noreferrer"
        style={{ color: "#ffffff" }}
      >
        Amparo
      </a>
      <Date>2023</Date>
    </ElementInverted>
  ) : (
    <Element>
      Fazenda Cósmica |{" "}
      <a
        href="https://goo.gl/maps/4HjVzJgsr1uRxTAX6"
        target="_blank"
        rel="noreferrer"
      >
        Amparo
      </a>
      <Date>2023</Date>
    </Element>
  );
}
